import classNames from 'classnames';
import * as gravatar from 'gravatar';
import { isNull, isString } from 'lodash-es';

type User = {
  vorname: string;
  nachname: string;
  image?: string | null;
  email?: string | null;
};

const getImageUrl = (user: User | null) => {
  if (!isNull(user) && isString(user.image)) {
    return user.image;
  }

  if (!isNull(user) && isString(user.email)) {
    return gravatar.url(user.email, {
      d: 'mp',
      s: '32',
    });
  }

  return '//www.gravatar.com/avatar/?d=mm&s=32&f=y';
};

type UserAvatarProps = {
  user: User | string;
  className?: string;
  size: 300 | 400 | 600;
};

export const UserAvatarLegacy = ({ user, size, className }: UserAvatarProps) => {
  const src = getImageUrl(isString(user) ? null : user);
  const name = isString(user) ? user : `${user.vorname} ${user.nachname}`;
  const alt = `Profilbild von ${name}`;
  const sizeClassNames = {
    300: 'w-300 h-300',
    400: 'w-400 h-400',
    600: 'w-600 h-600',
  }[size];

  return (
    <img className={classNames('border rounded-full border-primary', sizeClassNames, className)} src={src} alt={alt} />
  );
};

export default UserAvatarLegacy;
